import Button from "react-bootstrap/Button";
import type { ModalProps } from "react-bootstrap/Modal";
import QRCode from "react-qr-code";
import { useTranslation } from "react-i18next";
import { TEACHER_EVALUATION_TOKEN_PARAM } from "const";
import { Lightbox } from "components/Lightbox";
import { useToken } from "./useToken";

interface Props {
  className?: string;
  onHide: () => void;
  onSubmit: () => void;
  show: boolean;
  size?: ModalProps["size"];
  userAssignmentId: string;
}

// AIDEV-NOTE: `ariaLabel`, ne `title`/`bodyTitleId` — návrh tenhle lightbox nikde nepojmenovává
// (jen kroky ke QR kódu), stejný „čistě obrazový" případ jako Overtime.tsx. Bere se existující
// klíč `uploadTitle` sdílený s mobilní variantou (TeacherEvaluationUploadModal) — obě dělají
// totéž (odeslání vyfoceného řešení učiteli), jen jinou cestou. [TD-344]
const TeacherEvaluationQrCodeModal: React.FC<Props> = ({
  className,
  onHide,
  onSubmit,
  show,
  size = "lg",
  userAssignmentId,
}) => {
  const { t } = useTranslation("teacherEvaluation");
  const token = useToken();

  const urlToUpload = `${
    window.location.origin
  }/odeslani-uciteli/${userAssignmentId}?${TEACHER_EVALUATION_TOKEN_PARAM}=${token ?? ""}`;

  return (
    <Lightbox
      show={show}
      onHide={onHide}
      size={size}
      className={`modal--exercise ${className ?? ""}`}
      ariaLabel={t("uploadTitle")}
      bodyClassName="pb-60px pt-20px px-80px"
    >
      <div className={"qr-block mb-20px"}>
        <QRCode value={urlToUpload} className={"qr-block__code"} />
        <div className={"qr-block__inner"}>
          <p>{t("qrDescriptionRow1")}</p>
          <p>{t("qrDescriptionRow2")}</p>
          <p>{t("qrDescriptionRow3")}</p>
        </div>
      </div>

      <div className="d-grid gap-8px">
        <Button variant="primary" className={"w-100 fs-15"} onClick={onSubmit}>
          {t("buttonPhotoConfirm")}
        </Button>
        <Button variant="outline-secondary" className={"w-100 text-uppercase"} onClick={onHide}>
          {t("close")}
        </Button>
      </div>
    </Lightbox>
  );
};

export default TeacherEvaluationQrCodeModal;
